import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

import { TellentNavigationItemBadge } from '@core/tellent-types';
import { WalkthroughStepId } from '@core/walkthrough-types';

import { TellentNavigationLinkComponent } from '../navigation-link/navigation-link.component';

@Component({
  standalone: true,
  selector: 'tlc-navigation-group',
  styleUrls: ['./navigation-group.component.less'],
  template: `
    <tlc-navigation-link
      [testId]="testId() + '_menu'"
      [walkthroughId]="walkthroughId()"
      [href]="href()"
      [label]="label()"
      [icon]="dynamicIcon()"
      [badges]="badges()"
      [minimized]="minimized()"
      [isActive]="isActive()"
      [isChild]="isChild()"
      [isExpanded]="isExpanded()"
      (click)="toggle.emit()"
      (mouseenter)="expandIconVisible.set(true)"
      (mouseleave)="expandIconVisible.set(false)"
    />

    @if (isExpanded()) {
      <ng-content />
    }
  `,
  host: {
    '[class.expanded]': 'isExpanded()',
    '[class.minimized]': 'minimized()',
    '(mouseenter)': 'expandIconVisible.set(true)',
    '(mouseleave)': 'expandIconVisible.set(false)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TellentNavigationLinkComponent],
})
export class TellentNavigationGroupComponent {
  public isActive = input.required<boolean>();
  public isChild = input.required<boolean>();
  public isExpanded = input.required<boolean>();

  public href = input.required<string>();
  public minimized = input.required<boolean>();
  public label = input.required<string>();
  public icon = input<any>();
  public badges = input<TellentNavigationItemBadge[]>([]);
  public testId = input.required<string>();
  public walkthroughId = input<WalkthroughStepId>();

  public expandIconVisible = signal(false);

  public toggle = output<void>();

  public dynamicIcon = computed(() => {
    const minimized = this.minimized();
    const showExpand = this.expandIconVisible();
    const icon = this.icon();

    if (minimized) return icon;

    return showExpand ? 'arrow-drop-down' : this.icon();
  });
}
